import { render, staticRenderFns } from "./customerCases.vue?vue&type=template&id=32bd39e1&scoped=true"
import script from "./customerCases.vue?vue&type=script&lang=js"
export * from "./customerCases.vue?vue&type=script&lang=js"
import style0 from "./customerCases.vue?vue&type=style&index=0&id=32bd39e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bd39e1",
  null
  
)

export default component.exports